
    <pp-shell-dialog [title]="data.title | translate">
      <div class="confirmation" *ngIf="showConfirmation">
        <mat-icon class="check-icon">check</mat-icon>
        {{data.confirmationTitle | translate}}
      </div>
      <div *ngIf="!showConfirmation; else cancellationContent" mat-dialog-content>
        <p class="description">
          {{data.description | translate:
            ({ servicePhoneNumber: data.servicePhoneNumber })
          }}
        </p>
        <ng-container *ngIf="data.studentPhoneNumber">
          <span class="call">{{data.phone | translate}}</span>
          <span class="number">{{ data.studentPhoneNumber }}</span>
        </ng-container>
      </div>
      <ng-template #cancellationContent>
        <div mat-dialog-content>
          <p class="description confirmation-description">
            {{data.confirmationDescription | translate:
              ({ servicePhoneNumber: data.servicePhoneNumber })
            }}
          </p>
        </div>
      </ng-template>
      <div mat-dialog-actions *ngIf="!showConfirmation; else cancellationActions">
        <button (click)="onConfirm()" class="loading-btn" mat-flat-button color="accent">
          {{data.confirm | translate}}<mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
        </button>
        <button (click)="navigateToProfile()" class="call-me">{{data.editNumber | translate}}</button>
      </div>
      <ng-template #cancellationActions>
        <div class="confirmation-actions" mat-dialog-actions>
          <button mat-dialog-close mat-flat-button color="accent">{{data.confirmationClose | translate}}</button>
        </div>
      </ng-template>
    </pp-shell-dialog>
  